import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { MorphemeRouteStack } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels.route-body";
import { Stack } from "@-/com.npmjs.expo-router";

// Gives the `[morpheme]` route its own navigator so its route name is exactly `[morpheme]` (a
// dynamic segment) instead of the combined `morpheme/[morpheme]`. Expo Router's
// `findDivergentState`/`matchDynamicName` only detects a changed dynamic param — and thus pushes a
// *new* screen — when the route NAME itself is `[param]`; with the combined name it saw no
// divergence when navigating morpheme→morpheme (e.g. tapping a similar card in the info panel)
// and instead just switched the current card's inner info/mnemonics tab, leaving the character
// unchanged. This dedicated Stack layout restores the fresh push for each tapped grapheme.
//
// Character panels open immediately, whether pushed from Browse or another character.
export default function BrowseMorphemeStackLayoutRoute() {
  const [isEdgeNavigationEnabled] = useDeviceSetting("isEdgeNavigationEnabled");
  return (
    <MorphemeRouteStack
      screenOptions={{
        animation: "none",
        animationMatchesGesture: false,
        fullScreenGestureEnabled: false,
        gestureEnabled: isEdgeNavigationEnabled,
        headerShown: false,
      }}
    >
      <Stack.Screen name="[morpheme]" />
    </MorphemeRouteStack>
  );
}
